import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
//import SnGrid from "@shared/components/Grid/SnGrid";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnNumberBox from "@shared/components/SnNumberBox";
import SnLabel from "@shared/components/SnLabel";
import { RowNode } from "ag-grid-community";
import { SnButton } from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnTextBox from "@shared/components/SnTextBox";

interface popupProps {
  selectedDataList?: any;
  rowDataList?: any;
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_QMS_REQ_REG_002_POP_02 = forwardRef(
  (
    { selectedDataList, rowDataList, modalRef }: popupProps,
    ref: React.Ref<any>
  ) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion

    let [qt_pass, setQtPass] = useState<number>(0);
    let [qt_fail, setQtFail] = useState<number>(0);
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const isPassRow = (qt_value: number, ucl: number, lcl: number) =>
      ucl <= qt_value && qt_value <= lcl;

    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    const [doubleData, setDoubleData] = useState<any[]>();
    const [popupParent, setPopupParent] = useState<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        return await onSave();
      },
      getSelectedRow: () => [],
    }));

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_QMS_REQ_REG_002_POP_02",
            {}
          );

          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          const newFormData = {
            cd_item: selectedDataList.cd_item,
            nm_item: selectedDataList.nm_item,
            dc_item_spec: selectedDataList.dc_item_spec ?? " ",
            dc_item_unit: selectedDataList.dc_item_unit ?? " ",
            cd_sip: selectedDataList.cd_sip ?? " ",
            cd_clause: rowDataList.cd_clause ?? " ",
            dc_ucl: rowDataList.dc_ucl ?? " ",
            dc_lcl: rowDataList.dc_lcl ?? " ",
            qt_ac: rowDataList.qt_ac ?? "0",
            qt_re: rowDataList.qt_re ?? "0",
            yn_confirm: rowDataList.yn_confirm,
            nm_confirm: rowDataList.nm_confirm,
            no_lot: selectedDataList.no_lot,
            cd_firm: selectedDataList.cd_firm,
            no_line_cert: rowDataList.no_line,
          };

          setFormData(newFormData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          await onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_qms_req_reg_002_pop_02",
            params: selectedDataList,
          };

          const data: any = await fnGetDataSet(params);
          const rows = data?.[0] ?? [];
          setDataSources({
            grid1: rows,
          });
          let qt_pass = 0,
            qt_fail = 0;
          rows.forEach((row: any) => {
            if (row.yn_pass === "Y") qt_pass += 1;
            else qt_fail += 1;
          });
          setQtPass(qt_pass);
          setQtFail(qt_fail);
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {
          console.log(error);
        }
      };
      await fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      const grid = gridRefs.current["grid1"].current?.getChange();
      if (grid.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }
      const searchInfo = searchRef.current.getFormdata();
      const result = calculateResult(Number(searchInfo.qt_ac));
      setQtPass(result.passCnt);
      setQtFail(result.failCnt);
      setFormData((prev: any) => ({
        ...prev,
        nm_confirm: result.ynConfirm === "Y" ? "합격" : "불합격",
        yn_confirm: result.ynConfirm,
      }));
      const lotCerthChanges = {
        insert: [],
        delete: [],
        update: [
          {
            cd_firm: searchInfo.cd_firm,
            no_lot: searchInfo.no_lot,
            no_line: searchInfo.no_line_cert,
            yn_confirm: result.ynConfirm,
            qt_fail: result.failCnt,
            qt_pass: result.passCnt,
          },
        ],
        modifiedRowcount: 1,
      };
      const saveData = {
        lot_certh: lotCerthChanges,
        lot_certl: grid,
      };
      await fnSave("SN_QMS_REQ_REG_002_SAVE_01", saveData);
      return true;
    };
    const onAddRow = async () => {
      try {
        const searchInfo = searchRef.current.getFormdata();
        const maxNoLine =
          gridRefs.current["grid1"].current.getMaxValue("no_line");
        const length =
          rowDataList.qt_sample -
          gridRefs.current["grid1"].current?.getDisplayedRowCount();
        for (var i = 0; i < length; i++) {
          const newRow = {
            cd_firm: userInfo.cd_firm,
            no_lot: searchInfo.no_lot,
            no_line_cert: searchInfo.no_line_cert,
            no_line: maxNoLine + i + 1,
          };
          const rowNode = gridRefs.current["grid1"].current.addRow(newRow);
          rowNode.setDataValue("qt_value", 0);
        }
      } catch (error: any) {}
    };
    const onDeleteRow = async () => {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
        return;
      }

      gridRefs.current["grid1"].current?.deleteSelectedRows();

      const realDeletedRows =
        gridRefs.current["grid1"].current.getChange().delete ?? [];
      if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
        // 실제로 삭제된 행이 없으면 변경 사항을 적용하고 반환합니다.
        gridRefs.current["grid1"].current.resetUpdate();
        return;
      }
    };
    const onGridBtnsClick = async (id: string) => {
      if (id === "addRow") {
        onAddRow();
      } else if (id === "deleteRow") {
        onDeleteRow();
      }
    };
    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
    };
    const onCellValueChangedH = async (event: CellValueChangedEvent) => {
      const rowData = event.rowData;
      const colId = event.colId;
      const rowNode = event.rowNode;
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (colId !== "qt_value") return;

      const searchInfo = searchRef.current.getFormdata();

      const pass =
        Number(searchInfo.dc_lcl) <= Number(rowData.qt_value) &&
        Number(rowData.qt_value) <= Number(searchInfo.dc_ucl);
      rowNode.setDataValue("yn_pass", pass ? "Y" : "N", "noEvent");

      evaluateResult();
    };
    const calculateResult = (qtAc: number) => {
      let passCnt = 0,
        failCnt = 0;

      gridRefs.current["grid1"].current.forEachNode((node: RowNode) => {
        if (node.data?.yn_pass === "Y") passCnt++;
        else failCnt++;
      });

      return {
        passCnt,
        failCnt,
        ynConfirm: failCnt <= qtAc ? "Y" : "N",
      };
    };

    const evaluateResult = () => {
      const searchInfo = searchRef.current.getFormdata();
      const result = calculateResult(Number(searchInfo.qt_ac));

      const { passCnt, failCnt, ynConfirm } = result;
      setQtPass(passCnt);
      setQtFail(failCnt);

      if (ynConfirm === "Y") {
        setFormData((prev: any) => ({
          ...prev,
          nm_confirm: "합격",
          yn_confirm: "Y",
        }));
      } else {
        setFormData((prev: any) => ({
          ...prev,
          nm_confirm: "불합격",
          yn_confirm: "N",
        }));
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
            onCellValueChanged: onCellValueChangedH,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          />
        </div>
        <div
          style={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            gap: "10px",
            margin: "10px 0px 0px 0px",
          }}
        >
          <SnLabel text={"LOT수량"} type={"FreeForm"} />
          <SnNumberBox
            defaultValue={selectedDataList.qt_lot}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />
          <SnLabel text={"시료수량"} type={"FreeForm"} />
          <SnNumberBox
            defaultValue={rowDataList.qt_sample}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />

          <SnLabel text={"합격수량"} type={"FreeForm"} />
          <SnNumberBox
            defaultValue={qt_pass}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />
        </div>

        <div className="mb-4" style={{ textAlign: "center" }}></div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <SnTabHeader
            onBtnAddClick={onGridBtnsClick}
            onBtnDeleteClick={onGridBtnsClick}
          />
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              popupParent: popupParent,
              enableInitialSort: false,
              showFooter: false,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_QMS_REQ_REG_002_POP_02;
